function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  colorInterpolationFilters: "auto",
  id: "atoms-icon-trophy_inline_svg__a"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)",
  filter: "url(#atoms-icon-trophy_inline_svg__a)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M10.542 14.333a.124.124 0 00.125-.123c0-.3-.242-.543-.542-.543H8.333v-2.03c.786-.137 1.707-.754 2.32-2.018C12.582 9.333 14 7.825 14 6.533V5.25a.25.25 0 00-.25-.25h-2.417V3.917a.25.25 0 00-.25-.25H4.917a.25.25 0 00-.25.25V5H2.25a.25.25 0 00-.25.25v1.283c0 1.294 1.419 2.8 3.348 3.086.612 1.264 1.535 1.881 2.319 2.018v2.03H5.875c-.3 0-.542.243-.542.543 0 .07.057.123.125.123h5.084zM8 11c-1.5 0-2.667-2.167-2.667-4.833V4.333h5.334v1.834C10.667 8.833 9.5 11 8 11zm-.938-2.027l.936-.492.935.492a.23.23 0 00.334-.242l-.18-1.041.757-.738a.228.228 0 00-.125-.392l-1.046-.152-.469-.948a.229.229 0 00-.41 0l-.469.948-1.046.152a.23.23 0 00-.127.392l.756.738-.178 1.04a.23.23 0 00.333.242zm-2.01-.094c-1.43-.369-2.385-1.504-2.385-2.346v-.866h2v.5c0 1.079.145 1.977.385 2.712zm5.896 0c.24-.735.385-1.633.385-2.712v-.5h2v.866c0 .842-.958 1.977-2.385 2.346zM8.57 8.123l-.57-.3-.573.3.108-.638-.462-.45.64-.093.285-.58.285.58.64.093-.46.45.108.638z",
  fill: "#212121",
  fillRule: "nonzero"
}));

function SvgAtomsIconTrophyinline(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default SvgAtomsIconTrophyinline;